import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=c0af9d5e"
import script from "./Debt.vue?vue&type=script&lang=js"
export * from "./Debt.vue?vue&type=script&lang=js"
import style0 from "./Debt.vue?vue&type=style&index=0&id=c0af9d5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports